import { render, staticRenderFns } from "./BookstopBanner.vue?vue&type=template&id=8638b46c&scoped=true&"
import script from "./BookstopBanner.vue?vue&type=script&lang=js&"
export * from "./BookstopBanner.vue?vue&type=script&lang=js&"
import style0 from "./BookstopBanner.vue?vue&type=style&index=0&id=8638b46c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8638b46c",
  null
  
)

export default component.exports